<template>
  <div>
    <div class="sb_grid">
      <div class="sb_grid_container u_max-width-800 u_padding-top-40 u_margin-top-40">
        <p>
          <button
            class="sb_button v_has-icon-left v_icon-faded v_naked u_no-margin u_padding-left-0"
            :disabled="false"
            tag="button"
            @click="$router.go(-1)"
          >
            <ButtonObject icon="icon_ui_caret-left">
              Back
            </ButtonObject>
          </button>
        </p>
        <div class="sb_grid_column_1-1">
          <ContentHeader
            title="FAQ"
            icon="icon_question-mark-in-circle"
          />

          <!-- <h2 class="sb_label_heading">
            Download PDF
          </h2>
          <ul>
            <li>
              <a
                href="static/pdf/CLCM-Best-Practices_2019.pdf"
                target="_blank"
              >Best Practices</a>
            </li>
            <li>
              <a
                href="static/pdf/CLCM-User-Guidelines_2019.pdf"
                target="_blank"
              >User Guidelines</a>
            </li>
          </ul> -->
          <h2 class="sb_label_heading">
            Search in FAQ
          </h2>
          <div class="sb_input-and-button">
            <input
              v-model="search"
              type="text"
              placeholder="Search in FAQ"
            >
            <!-- eslint-disable max-len -->
            <button
              class="sb_button v_naked u_padding-left-20 u_padding-right-10 u_padding-top-0 u_padding-bottom-5"
              @click="search = ''"
            >
              <ButtonObject icon="icon_ui_close" />
            </button>
            <!-- eslint-enable max-len -->
          </div>


          <br>
          <br>
          <FaqComponent
            :search="search"
            :faq-data="faqData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/assemblies/content-header';
import FaqComponent from '@/components/objects/faq-component';
import faqData from '@/data/faq';

export default {
  name: 'Faq',
  components: {
    ContentHeader,
    FaqComponent
  },
  data() {
    return {
      search: '',
      faqData
    };
  },
  methods: {
    back() {

    }
  }
};
</script>
